import ApiService from "./axios/Apiservices";

export const getALLproducts = async () => {
    return ApiService.get("/productlist");
};

export const getProduct = async (id) => {
    return ApiService.get(`/product/${id}`);
};
let newArrivalsCache = null;
let bestSellersCache = null;

export const getNewArrivalProducts = async () => {
    if (newArrivalsCache) return newArrivalsCache;
    const res = await ApiService.get("/products/new-arrivals");
    newArrivalsCache = res;
    return res;
};

export const getBestSellerProducts = async () => {
    if (bestSellersCache) return bestSellersCache;
    const res = await ApiService.get("/products/best-sellers");
    bestSellersCache = res;
    return res;
};

export const getMostViewedProducts = async () => {
    return ApiService.get("/products/most-viewed");
};

export const getTrendingListProducts = async () => {
    return ApiService.get("/products/trending");
};